(ns ycweb.app.website.myaccount.newsletters.newsletters
  (:require
   [ycweb.components.flow :as flow]
   [rum.core :as rum]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.headings :as headings]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.common :as cmn]))

(def three-or-more-uuid #uuid"f53fddbe-8eda-4776-99ac-62096742b7c1")

(rum/defc newsletters < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        newsletters-atom (rum/cursor-in action-atom [:newsletters])
        special-interests-atom (rum/cursor-in action-atom [:special-interests])
        three-or-more-atom (rum/cursor-in newsletters-atom [three-or-more-uuid :interest/selected?])
        special-interests (rum/react special-interests-atom)]
    [:div
     [:div.yc-section
      (headings/heading "Email Preferences" {:type :h2 :size :medium})]
     [:div
      {:class (u/bem :yc-section [:large])}
      [:form.form.u-max-width-640
       [:div
        {:class (u/bem :form-section [:lined])}

        (headings/heading "You are currently subscribed to:"
          {:type :h3 :size :small})

        [:div.u-margin-top-30
         {:class (u/bem :form-section [:lined])}
         [:label.form-field.toggle-label
          {:for (str "special-interests-surveys-footer" "newsletter") :key "newsletter"}
          [:input.toggle
           (merge
             (input-forms/checkbox-props
               three-or-more-atom
               #(grid/dispatch-action app-atom :web.myaccount/newsletter-choose-interest {:special-interests-labels ["Personalised offers"]})
               nil
               false
               false)
             {:id (str "special-interests-surveys-footer" "newsletter")})]
          [:span.toggle__graphic-wrapper
           [:span.toggle__graphic]]
          [:span.toggle__text
           [:span.toggle__title "Newsletters and personalised offers"]
           [:span "Find out first about new launches and deals, plus the chance to receive occasional vouchers"]]]
         (map
           (fn [[uuid interest]]
             [:label.form-field.toggle-label
              {:for (str "special-interests-surveys-footer" uuid) :key uuid}
              [:input.toggle
               (merge
                 (input-forms/checkbox-props
                   (rum/cursor-in special-interests-atom
                     [uuid :interest/selected?])
                   #(grid/dispatch-action app-atom :web.myaccount.newsletters/savenewsletterinterest {})
                   nil
                   (rum/react three-or-more-atom)
                   false)
                 {:id (str "special-interests-surveys-footer" uuid)})]
              [:span.toggle__graphic-wrapper
               [:span.toggle__graphic]]
              [:span.toggle__text
               [:span.toggle__title
                (when (= (:ent/display-name interest) "Personalised offers")
                  "Personalised offers only")]
               (when (= (:ent/display-name interest) "Personalised offers")
                 [:span "Sign up for the chance of occasional personalised vouchers, without getting our newsletters"])]])
           special-interests)]]]
      (toaster/loading-overlay app-atom :web.myaccount/newsletters)]]))

(defmethod flow/render-screen :web.myaccount/newsletters [app-atom _]
  (awm.common/screen-wrapper app-atom
    (newsletters app-atom)))

(defmethod t/transition-open :web.myaccount/newsletters [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/newsletters)
  (comms/ajax-get :web.myaccount/newsletters {}))

(defmethod comms/receive :web.myaccount/newsletters [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/newsletters)
  (swap!
    (cmn/action-cursor app-atom) assoc
    :newsletters (:newsletters e)
    :user (:user e)
    :special-interests (:special-interests e)))

(defmethod grid/action :web.myaccount/newsletter-choose-interest [app-atom config _]
  (let [action-atom (cmn/action-cursor app-atom)
        special-interests-atom (rum/cursor-in action-atom [:special-interests])
        newsletters-atom (rum/cursor-in action-atom [:newsletters])
        newsletter-interest
        (->>
          @newsletters-atom
          (vals)
          (filter :interest/selected?)
          (map :ent/uuid)
          (remove nil?)
          (first))
        special-interests-labels (set (:special-interests-labels config))
        interests-to-select (filter #(contains? special-interests-labels (:ent/display-name %)) (vals @special-interests-atom))
        final-interests (map #(assoc % :interest/selected? true) interests-to-select)
        action-name (cmn/action-cursor-path app-atom)]
    (swap! app-atom update action-name
      (fn [action]
        (->
          action
          (assoc-in [:user :user/newsletter :ent/uuid] newsletter-interest)
          (update :special-interests
            (fn [special-interests]
              (if (not (nil? newsletter-interest))
                (reduce
                  (fn [acc interest]
                    (assoc acc (:ent/uuid interest) interest))
                  special-interests final-interests)
                special-interests))))))
    (grid/dispatch-action app-atom :web.myaccount.newsletters/savenewsletterinterest {})))

(defmethod grid/action :web.myaccount.newsletters/savenewsletterinterest [app-atom config _]
  (toaster/open-toast app-atom :processing "Saving" {:closetime 10000})
  (let [state-atom (cmn/action-cursor app-atom)
        user-newsletter-label-uuid-atom (rum/cursor-in state-atom [:user :user/newsletter :ent/uuid])
        special-interests-atom (rum/cursor-in state-atom [:special-interests])

        special-interest
        (->>
          @special-interests-atom
          (vals)
          (filter :interest/selected?)
          (map :ent/uuid)
          (remove nil?))]

    (comms/ajax-post :web.myaccount/savenewsletterinterest
      {:user
       {:user/interests
        (conj special-interest @user-newsletter-label-uuid-atom)}})))

(defmethod comms/receive :web.myaccount/savenewsletterinterest [app-atom e]
  (toaster/close-toast app-atom)
  (toaster/open-toast app-atom :success "Saved" {:closetime 2000}))
